// @flow strict

// $FlowFixMe
export const buildUrlQueryString = (paramsObject: Object): string =>
  new URLSearchParams(paramsObject).toString();
